import React from "react";
import { render } from "react-dom";
import { NotAvailableBox } from ".";
import { DesignContextProvider } from "Components/DesignContext";
import { Provider } from "react-redux";


export function init(model: Readonly<LSCommon.Service.LSWebUI.Models.XPP.XppLandingPageJsViewModel>, onClaim: () => void) {
   const container = document.getElementById("xpp-nabox-container");

   if (!container) {
      return;
   }

   const checkAvailabilityButton = document.getElementById("xpp-nabtn");

   render(<Provider store={LSStore.instance}>
      <DesignContextProvider name="primary">
         <NotAvailableBox
            venueId={model.VenueId}
            isClaimable={model.IsClaimable}
            onClaim={onClaim}
            citySearchUrl={model.CitySearchUrl ?? undefined}
            checkAvailabilityButton={checkAvailabilityButton instanceof HTMLButtonElement ? checkAvailabilityButton : undefined}
         />
      </DesignContextProvider>
   </Provider>, container);
}
